import React, { useState } from 'react';
import * as S from './BarrierDetails.style';
import FlorenzButton from '../../../../../../../../../../florenzComponents/florenzButton';
import * as P from "../../../../../../../../../../../utils/pipes";
import { useTranslation } from "react-i18next";

const BarrierDetails = ({ barrier, onBack }) => {
  const {t, i18n: { language }} = useTranslation("global");
  const [isEditing, setIsEditing] = useState(false);
  const [severityLevel, setSeverityLevel] = useState(parseInt(barrier?.severity) || 1);

  if (!barrier) return null;

  if (isEditing) {
    return (
      <S.Container>
        <S.Header>
          <h2><i className="icon zaia-icono-editar" style={{marginRight: '10px'}}></i> Editando...</h2>
        </S.Header>
        
        <S.EditForm>
          <div className="select-container">
            <label>Tipo de barrera <i className="icon zaia-icono-abajo"></i></label>
            <div className="value-text">{P.dataTranslation(barrier?.subTypeBarrier?.typeBarrier?.name, language)}</div>
            <div className="select-arrow-bg">
              <i className="icon zaia-icono-abajo"></i>
            </div>
          </div>

          <div className="select-container">
            <label>Sub tipo <i className="icon zaia-icono-abajo"></i></label>
            <div className="value-text">{P.dataTranslation(barrier?.subTypeBarrier?.name, language)}</div>
            <div className="select-arrow-bg">
              <i className="icon zaia-icono-abajo"></i>
            </div>
          </div>

          <div className="severity-container">
            <label>Nivel de severidad</label>
            <div className="severity-selector">
              <div 
                className={`severity-option ${severityLevel === 1 ? 'active' : ''}`}
                onClick={() => setSeverityLevel(1)}
              >1</div>
              <div 
                className={`severity-option ${severityLevel === 2 ? 'active' : ''}`}
                onClick={() => setSeverityLevel(2)}
              >2</div>
              <div 
                className={`severity-option ${severityLevel === 3 ? 'active' : ''}`}
                onClick={() => setSeverityLevel(3)}
              >3</div>
            </div>
          </div>

          <div className="textarea-container">
            <textarea 
              defaultValue={barrier?.description} 
            />
            <button className="mic-btn">
              <i className="icon zaia-icono-microfono"></i>
            </button>
          </div>
        </S.EditForm>

        <S.Footer>
          <button className="cancel-btn" onClick={() => setIsEditing(false)}>Cancelar</button>
          <div className="actions">
            <button className="save-btn" onClick={() => setIsEditing(false)}>Guardar cambios <span>✓</span></button>
          </div>
        </S.Footer>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.Header>
        {
          barrier.barrierStatus === "pending" || barrier.barrierStatus === "in progress"
          ? <div className='title'>Barrera pendiente</div>
          : <div className='title'>Barrera resuelta</div> 
        }
      </S.Header>
      
      <S.Details>
        <p className="type">Barrera de tipo <strong>{P.dataTranslation(barrier?.subTypeBarrier?.typeBarrier?.name, language)}</strong> (Nivel de severidad {barrier?.severity})</p>
        <p className="subtype">{P.dataTranslation(barrier?.subTypeBarrier?.name, language)}</p>
        <p className="registered">Registrado en {P.longDate(barrier?.created_at, t, language)}</p>
        
        <div className="resolve-date">
          <span>{barrier.barrierStatus === "completed" ? "Se resolvió el:" : "Debe resolverse para:"}</span>
          <div className="date-pill">
            <i className="icon zaia-i-calendar-2"></i> {barrier.barrierStatus === "completed" ? P.longDate(barrier?.solutionDate, t, language) : P.longDate(barrier?.estimatedSolutionDate, t, language)}
          </div>
        </div>
      </S.Details>

      <S.Divider />

      <S.BodyText>
        {barrier?.description}
      </S.BodyText>

      {
        barrier.barrierStatus !== "completed"
        ? <S.Footer>
          <FlorenzButton
            typeStyle={"secondary"}
            size="s"
            text={"Cancelar"}
            onClick={onBack}
          />
          <div className="actions">
            <FlorenzButton
              typeStyle={"secondary"}
              size="s"
              icon="zaia-i-trash-can"
              iconSize={"15"}
            />
            <FlorenzButton
              typeStyle={"secondary"}
              size="s"
              icon="zaia-i-pen"
              iconSize={"15"}
              onClick={() => setIsEditing(true)}
            />
            <FlorenzButton
              typeStyle={"success"}
              size="s"
              icon="zaia-i-check-1"
              iconSize={"11"}
              text={"Completar"}
              onClick={onBack}
            />
          </div>
        </S.Footer>
        : <S.Footer>
          <button className="cancel-btn" onClick={onBack}>Cancelar</button>
          <div className="actions">
            <button className="cancel-btn">Marcar como pendiente</button>
          </div>
        </S.Footer>
      }
    </S.Container>
  );
};

export default BarrierDetails;
